(() => {
  if (window.morkasSockCrossSellInitialized) return;
  window.morkasSockCrossSellInitialized = true;

  const updateCarouselButtons = (list) => {
    const module = list.closest('[data-morkas-sock-cross-sell]');
    if (!module) return;
    const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
    module.querySelector('[data-sock-carousel-direction="previous"]').disabled = list.scrollLeft <= 2;
    module.querySelector('[data-sock-carousel-direction="next"]').disabled = list.scrollLeft >= maxScroll - 2;
  };

  const loadDiscovery = (root = document) => {
    root.querySelectorAll('[data-morkas-sock-cross-sell][data-discovery-url]').forEach(async (module) => {
      if (module.dataset.discoveryRequested) return;
      module.dataset.discoveryRequested = 'true';
      const list = module.querySelector('[data-sock-carousel]');
      try {
        const response = await fetch(module.dataset.discoveryUrl);
        if (!response.ok) throw new Error('No se pudieron cargar los complementos.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const discoveryList = html.querySelector('[data-morkas-discovery-complements]');
        if (!discoveryList) throw new Error('La sección de complementos no está disponible.');
        const cards = [...discoveryList.querySelectorAll(':scope > .morkas-sock-cross-sell__item')];
        if (cards.length && !list.querySelector('[data-sock-variant]:checked')) {
          list.replaceChildren(...cards);
          list.scrollLeft = 0;
          module.hidden = false;
          module.dataset.recommendationSource = 'discovery';
          updateCarouselButtons(list);
          updateSelection(module);
        } else if (!cards.length && !list.querySelector('.morkas-sock-cross-sell__item')) {
          module.hidden = true;
        }
      } catch (_) {
        if (!list.querySelector('.morkas-sock-cross-sell__item')) module.hidden = true;
      }
    });
  };

  const initializeCarousels = (root = document) => {
    root.querySelectorAll('[data-sock-carousel]').forEach((list) => {
      if (list.dataset.carouselReady) return;
      list.dataset.carouselReady = 'true';
      list.addEventListener('scroll', () => updateCarouselButtons(list), { passive: true });
      updateCarouselButtons(list);
    });
    loadDiscovery(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCarousels());
  } else {
    initializeCarousels();
  }
  document.addEventListener('shopify:section:load', (event) => initializeCarousels(event.target));
  window.addEventListener('resize', () => {
    document.querySelectorAll('[data-sock-carousel]').forEach(updateCarouselButtons);
  });

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-sock-carousel-direction]');
    if (!arrow) return;
    const list = arrow.closest('[data-morkas-sock-cross-sell]')?.querySelector('[data-sock-carousel]');
    const firstCard = list?.querySelector('.morkas-sock-cross-sell__item');
    if (!firstCard) return;
    const step = firstCard.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0);
    list.scrollBy({
      left: arrow.dataset.sockCarouselDirection === 'next' ? step : -step,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  });

  const updateSelection = (module) => {
    const inputs = [...module.querySelectorAll('[data-sock-variant]')];
    inputs.forEach((input) => input.closest('.morkas-sock-cross-sell__option').classList.toggle('is-selected', input.checked));
    const count = inputs.filter((input) => input.checked).length;
    module.querySelector('[data-sock-selection-state]').textContent = count
      ? `${count} ${count === 1 ? 'complemento seleccionado' : 'complementos seleccionados'} · Se agregarán con tu producto.`
      : 'Desliza para ver más complementos. Selecciona los que quieras agregar.';
  };

  const syncSelections = (root = document) => {
    root.querySelectorAll('[data-morkas-sock-cross-sell]').forEach(updateSelection);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncSelections());
  } else {
    syncSelections();
  }
  document.addEventListener('shopify:section:load', (event) => syncSelections(event.target));
  window.addEventListener('pageshow', () => syncSelections());

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-sock-variant]');
    if (input) updateSelection(input.closest('[data-morkas-sock-cross-sell]'));
  });

  document.addEventListener('morkas:socks-added', (event) => {
    const module = event.target.closest('[data-morkas-sock-cross-sell]');
    if (!module) return;
    module.querySelectorAll('[data-sock-variant]:checked').forEach((input) => { input.checked = false; });
    updateSelection(module);
  });
})();
